<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "TemplatesWrapper"
    }
</script>

<style scoped>

</style>